import React, { useEffect, useState } from "react";
import { fetchApplications } from "./helpers";
import { BellIcon } from "./Components";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import { Tab, Tabs, Box, Card } from "@mui/material";
import { useTranslation } from "react-i18next";
import TabPanel from "../../../pageComponents/TabPanel";
import { convertEpochToDateDMY } from "../../../utils";
import NoRecords from "../NoRecordCard/NoRecord";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import NotificationChatboard from "../Notifications";
import { useDispatch } from "react-redux";
import { updateFormData } from "@egovernments/digit-ui-module-core/src/redux/actions/empInbox";
// import { useApplications } from "../../../../Context/ApplicationsProvider/ApplicationsProvider";
const tablist = [
  { label: "LTP Registration", color: "black" },
  { label: "Other Module Applications", color: "black" },
  { label: "Notifications", color: "black" },
];

const EmpMenu = ({ userBusinessServices, tenantId, officerRole }) => {
  const history = useHistory();
  const { applications, isOfficerLTP } = fetchApplications(tenantId, userBusinessServices, officerRole);
  const dispatch = useDispatch();

  //  const { applications} = useContext(ApplicationsContext);
  // const { applications, isFetching, isOfficerLTP } = useApplications();
  // const { applications, isFetching, isOfficerLTP } = useContext(ApplicationsContext);
  console.log("fetchedApplications", applications);
  console.log("officer role --- ", officerRole);
  const applicationsCount = applications?.totalCount;
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);
  const [currentTab, setCurrentTab] = useState("1");
  const { t } = useTranslation();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };
  const handleChange = (event, nextTab) => {
    setCurrentTab(nextTab);
  };

  const navigateProfessional = (item) => {
    history.push(`/digit-ui/employee/obps/professional/${item?.applicationId}`);
    handleClose();
  };
  const handleTakeAction = (item) => {
    console.log("itemFromTakeAction", item);
    switch (item?.businessService) {
      case "BPA_MAPSUB_DA":
      case "BPA_MAPSUB_AVP":
        history.push(`/digit-ui/employee/obps/application/MAP_SUB/${item?.applicationId}`);
        handleClose();
        break;
      case "BPA_FAR_DA":
      case "BPA_FAR_AVP":
        history.push(`/digit-ui/employee/obps/application/PURCHASABLE_FAR/${item?.applicationId}`);
        handleClose();
        break;
      case "BPA_LANDUSE_DA":
      case "BPA_LANDUSE_AVP":
        history.push(`/digit-ui/employee/obps/application/formLandUse/${item?.applicationId}`);
        handleClose();
        break;
    }
    // setAnchorEl(false);
  };

  useEffect(() => {
    if (applications?.table?.length > 0) {
      setCurrentTab("0");
    } else {
      setCurrentTab("1");
    }
  }, [applications]);

  useEffect(() => {
    setCurrentTab("2");
  }, []);
  useEffect(() => {
    if (applications) {
      dispatch(updateFormData(userBusinessServices, tenantId, applicationsCount, officerRole));
    }
  }, [applications]);

  return (
    <React.Fragment>
      {/* <BellIcon handleClick={handleClick} applicationsCount={applicationsCount} /> */}
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        sx={{ zIndex: 10000 }}
      >
        <Card sx={{ backgroundColor: "#ecf2f7", color: "#8090a0" }}>
          <MenuItem>
            <Tabs value={currentTab} onChange={handleChange}>
              {tablist.map(({ label, color }, index) => (
                <Tab
                  key={index}
                  label={`${t(label)}`}
                  value={`${index}`}
                  sx={{ textTransform: "none", p: "0 1rem", color, border: "1px solid #555" }}
                />
              ))}
            </Tabs>
          </MenuItem>
        </Card>
        <TabPanel value={currentTab} index="0" sx={{ p: 0 }}>
          <div>
            {isOfficerLTP &&
              applications?.table?.map((item) => {
                return (
                  <Card key={item.owner + item.date} sx={{ display: "flex", marginBottom: "3px", width: "100%" }}>
                    <Box sx={{ width: "25%", margin: "3px" }}>
                      <Box sx={{ width: "65px", height: "60px", border: "1px solid", marginLeft: "10px" }}>
                        <img width="60px" height="52px" src={item?.userPhoto} />
                      </Box>
                    </Box>
                    <Box sx={{ width: "50%" }}>
                      <div>
                        <b>{item.owner}</b>
                      </div>
                      {/* <div style={{ fontSize: "11px", color: "#1976d2" }}>{item.businessService}</div> */}
                      <div style={{ fontSize: "11px", color: "#1976d2" }}>{item.applicationId}</div>
                      <div style={{ fontSize: "11px", color: "#1976d2" }}>{t(`EMP_${item.applicationType}`)}</div>
                      <div style={{ fontSize: "11px" }}>Applied on : {convertEpochToDateDMY(item.date)}</div>
                    </Box>
                    <Box sx={{ width: "25%", marginRight: "10px", marginTop: "20px" }}>
                      {/* LTP registration actions below */}
                      <Button
                        size="small"
                        sx={{ ml: 1, fontSize: "11px", alignContent: "center" }}
                        variant="contained"
                        color="success"
                        onClick={() => navigateProfessional(item)}
                      >
                        Take Action
                      </Button>
                    </Box>
                  </Card>
                );
              })}

            {/* Queries: can there be any case where officer can see LTP as well as other modules application */}
            {((isOfficerLTP && applications?.table?.length <= 0) || !isOfficerLTP) && (
              <div>
                <NoRecords />
              </div>
            )}
          </div>
        </TabPanel>
        <TabPanel value={currentTab} index="1" sx={{ p: 0 }}>
          <div>
            {!isOfficerLTP &&
              applications?.table?.map((item) => {
                return (
                  <div key={item.applicationId}>
                    <React.Fragment>
                      <Card sx={{ display: "flex", marginBottom: "3px", width: "100%" }}>
                        <Box sx={{ width: "25%", margin: "3px" }}>
                          <Box sx={{ width: "65px", height: "60px", border: "1px solid", marginLeft: "10px" }}>
                            <img width="60px" height="52px" src={item?.userPhoto} />
                          </Box>
                        </Box>
                        <Box sx={{ width: "50%" }}>
                          <div>
                            <b>{item.owner}</b>
                          </div>
                          <div style={{ fontSize: "11px", color: "#1976d2" }}>{item.applicationId}</div>
                          <div style={{ fontSize: "11px", color: "#1976d2" }}>{t(`EMP_${item.applicationType}`)}</div>
                          <div style={{ fontSize: "11px" }}>Applied On : {convertEpochToDateDMY(item.date)}</div>
                        </Box>
                        <Box sx={{ width: "25%", marginRight: "10px", marginTop: "20px" }}>
                          <Button
                            size="small"
                            sx={{ ml: 1, fontSize: "11px", alignContent: "center" }}
                            variant="contained"
                            color="success"
                            onClick={() => handleTakeAction(item)}
                          >
                            Take Action
                          </Button>
                        </Box>
                      </Card>
                    </React.Fragment>
                  </div>
                );
              })}

            {isOfficerLTP && (
              <div>
                <NoRecords />
              </div>
            )}
          </div>
        </TabPanel>
        <TabPanel value={currentTab} index="2" sx={{ p: 0 }}>
          <div>
            <NotificationChatboard />
          </div>
        </TabPanel>
      </Menu>
    </React.Fragment>
  );
};
export default EmpMenu;
